import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router'
import {Link} from 'react-router-dom'
import {getOnlineRate, getWarningList, getStrongAlarmInfo} from '@apis'
import cs from 'classnames'
import moment from 'moment'
import Button from '@components/button'
import headerback from '@assets/img/header-back.png'
import './index.less'
import headerbutton from '../../../assets/img/header-button.png'
import logo from '../../../assets/img/logo.png'

let timer
let warningTimer

const CockpitHeader = inject('store')(
  observer(({
    store,
    location,
    history,
  }) => {
    const {userInfo, userLogout} = store
    const [curTime, setCurTime] = useState(new Date())
    const [curCity, setCurCity] = useState()
    const [fullType, setFullType] = useState(!!document.fullscreenElement || !!document.msFullscreenElement || !!document.mozFullScreenElement || !!document.webkitFullscreenElement)
    const {
      pathname,
    } = location
    const [nodeWarning, setNodeWarning] = useState(false)
    const [deviceWarning, setDeviceWarning] = useState(false)
    const {strongProjectId: projectId, brokerId} = userInfo

    // 获取节点信息  
    async function queryNodeWarning() {
      const nodeParams = {
        brokerId
      }
      const res = await getOnlineRate(nodeParams)
      if (res) {
        if(res.totalCount !== res.onlineCount) {
          setNodeWarning(true)
        }
      }
    }

    // 获取强电信息
    async function queryWarning() {
      const deviceParams = {
        brokerId,
        projectId,
        pageNo: 1,
        pageSize: 9999
      }
      const value = projectId ? await getWarningList(deviceParams) : await getStrongAlarmInfo(deviceParams)
      if (value && value.data) {
        const warn = value.data.filter(item => item.r===false)
        if(warn.length) {
          setDeviceWarning(true)
        }
      }
    }


    // 定时轮询当前时间
    function intervalTime() {
      setInterval(() => {
        setCurTime(new Date())
      }, 1000)
    }

    //查询现在所在位置城市
    function showCityInfo() { 
      //加载城市查询插件 
      AMap.service(["AMap.CitySearch"], function() { 
        //实例化城市查询类 
        var citysearch = new AMap.CitySearch(); 
        //自动获取用户IP，返回当前城市 
        citysearch.getLocalCity(function(status, result){ 
          if(status === 'complete' && result.info === 'OK'){ 
            if(result && result.city && result.bounds) {
              setCurCity(result.city)
            } 
          }else{
          } 
        }); 
      }); 
    }

    function fullScreen() {
      if(!fullType) {
        if(document.documentElement.RequestFullScreen){
          document.documentElement.requestFullscreen();
        }
        //兼容火狐
        console.log(document.documentElement.mozRequestFullScreen)
        if(document.documentElement.mozRequestFullScreen){
          document.documentElement.mozRequestFullScreen();
        }
        //兼容谷歌等可以webkitRequestFullScreen也可以webkitRequestFullscreen
        if(document.documentElement.webkitRequestFullScreen){
          document.documentElement.webkitRequestFullScreen();
        }
        //兼容IE,只能写msRequestFullscreen
        if(document.documentElement.msRequestFullscreen){
          document.documentElement.msRequestFullscreen();
        }
      } else {
        if(document.exitFullScreen){
          document.exitFullscreen()
        }
        //兼容火狐
        if(document.mozCancelFullScreen){
          document.mozCancelFullScreen()
        }
        //兼容谷歌等
        if(document.webkitExitFullscreen){
          document.webkitExitFullscreen()
        }
        //兼容IE
        if(document.msExitFullscreen){
          document.msExitFullscreen()
        }
      }
      setFullType(!fullType)
    }

    useEffect(() => {
      if(userInfo) {
        clearInterval(warningTimer)
        warningTimer = setInterval(() => {
          queryNodeWarning()
          if(userInfo.strongProjectId) {
            queryWarning()
          }
        }, 2000)
      }
      showCityInfo()
      intervalTime()
      clearInterval(timer)
      timer = setInterval(() => {
        setFullType(!!document.fullscreenElement || !!document.msFullscreenElement || !!document.mozFullScreenElement || !!document.webkitFullscreenElement)
      }, 1000)
    }, [curCity])

    const curYear = moment(curTime).format('YYYY.MM.DD HH:mm:ss')

    return (
      <div className="cockpit-title">
        <div className='overflow-logo'>
          <img src={logo} className="logo-img"/>
          <span>智慧照明管理云平台V6.0</span>
        </div>
        {
          userInfo && (
            <div className="cockpit-logout">
              <Link to="/overview"><img src={headerback} className='back-to-control'/></Link>
              <span className="cockpit-header-sp">
                {userInfo.userName}
                <Button
                  className="login-out"
                  onClick={() => {
                    userLogout()
                    history.push('/login')
                  }}
                >
                  退出登录
                </Button>
                <Button
                  className="login-out last"
                  onClick={() => {
                    fullScreen()
                  }}
                >
                  {fullType ? '退出全屏' : '全屏'}
                </Button>
              </span>
            </div>
          )
        }
        <div className="cockpit-tabs">
          <Link
            to="/cockpit/index"
            className={cs({
              "cockpit-tab-item": true,
              "tabsActive": pathname.indexOf('/cockpit/index') > -1,
              "warning": nodeWarning || deviceWarning,
            })}
          >
            <img className='cockpit-tab-img' src={headerbutton}/>
            <div>智慧驾驶舱</div>
          </Link>
          <Link
            to="/cockpit/lightControl"
            className={cs({
              "cockpit-tab-item": true,
              "tabsActive": pathname.indexOf('/cockpit/lightControl') > -1,
            })}
          >
            <img className='cockpit-tab-img' src={headerbutton}/>
            <div>智慧灯光</div>
          </Link>
          <Link
            to="/cockpit/timeline"
            className={cs({
              "cockpit-tab-item": true,
              "tabsActive": pathname.indexOf('/cockpit/timeline') > -1,
            })}
          >
            <img className='cockpit-tab-img' src={headerbutton}/>
            <div>智慧演绎</div>
          </Link>
          <Link
            to="/cockpit/energyStatistics"
            className={cs({
              "cockpit-tab-item": true,
              "tabsActive": pathname.indexOf('/cockpit/energyStatistics') > -1,
            })}
          >
            <img className='cockpit-tab-img' src={headerbutton}/>
            <div>智慧强电</div>
          </Link>
          <Link
            to="/cockpit/realtimeMonitor"
            className={cs({
              "cockpit-tab-item": true,
              "tabsActive": pathname.indexOf('/cockpit/realtimeMonitor') > -1,
            })}
          >
            <img className='cockpit-tab-img' src={headerbutton}/>
            <div>智慧安防</div>
          </Link>
          <Link
            to="/cockpit/clientManagement"
            className={cs({
              "cockpit-tab-item": true,
              "tabsActive": pathname.indexOf('/cockpit/clientManagement') > -1,
            })}
          >
            <img className='cockpit-tab-img' src={headerbutton}/>
            <div>智慧管控</div>
          </Link>
        </div>
        <div className='cockpit-time'>
          <div className="time-box">
            <div className="time-item">
              <div className="time-top">
                {curYear}
              </div>
            </div>
            <div className="time-line" />
            <div className="time-item">
              <div className="time-top">
                中国   ·   {curCity ? curCity.replace("市", "") : '--'}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  })
)

export default withRouter(CockpitHeader)